import { Box, GlobalStyles } from '@mui/material'
import { useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'

import SplitAuthLayout from '../SplitAuthLayout/SplitAuthLayout.component'

interface Props {
  welcome?: string
  showLanguageSwitcher?: boolean
}

const AuthLoading = ({ welcome, showLanguageSwitcher }: Props) => {
  const intl = useIntl()
  const text = welcome ?? intl.formatMessage({ id: 'loading.default' })
  return (
    <SplitAuthLayout dataTestId='auth-loading' showLanguageSwitcher={showLanguageSwitcher}>
      <GlobalStyles
        styles={{
          '@keyframes paretos-loading-bar': {
            from: { transform: 'translateX(-100%)' },
            to: { transform: 'translateX(350%)' },
          },
        }}
      />
      <Box
        role='status'
        aria-live='polite'
        aria-busy='true'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <Box
          sx={{
            fontSize: { xl: 22, md: 20, xs: 18 },
            fontWeight: 500,
            color: tokens.businessBlack,
          }}
        >
          {text}
        </Box>
        {/* Indeterminate linear bar with the paretos gradient. */}
        <Box
          aria-hidden='true'
          sx={{
            width: 220,
            maxWidth: '100%',
            height: 4,
            borderRadius: tokens.radiusPill,
            background: tokens.businessBlack5Solid,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              width: '40%',
              borderRadius: tokens.radiusPill,
              background: tokens.paretosGradient,
              animation: 'paretos-loading-bar 1.2s ease-in-out infinite',
            }}
          />
        </Box>
      </Box>
    </SplitAuthLayout>
  )
}

export default AuthLoading
